// frontend/packages/business-console/src/services/leadFormService.js
//
// Thin client over /api/v2/lead-form (read-only view of the public
// contact/estimate form definition). The form's funnel comes from the
// existing /v2/visitors/funnel endpoint (see visitorsService).

import { api } from '@upryzze/services';

/**
 * GET /api/v2/lead-form
 * Read-only public form definition for the active business:
 *   { exists, slug, name, status, version, fieldCount, requiredCount,
 *     attachmentsEnabled, fields: [{ key, label, type, required }] }
 */
export async function getLeadFormDefinition() {
  const { data } = await api.get('/v2/lead-form');
  return data || { exists: false };
}

/**
 * GET /api/v2/lead-form/forms
 * ALL active public forms for the active business (a tenant can run more
 * than one). Same sanitized shape as getLeadFormDefinition, per form:
 *   { forms: [{ slug, name, status, version, fieldCount, requiredCount,
 *     attachmentsEnabled, fields }] }
 */
export async function getLeadForms() {
  const { data } = await api.get('/v2/lead-form/forms');
  return data && Array.isArray(data.forms) ? data : { forms: [] };
}

/**
 * GET /api/v2/lead-form/trends?weeks=&form=
 * Weekly leads (spam excluded), split by the form's "How did you hear about
 * us?" answer when it has one. Per-tenant feature (`lead_trends`):
 *   { enabled: false }  or
 *   { enabled: true, form: { slug, name } | null,
 *     sourceField: { key, label } | null, timeZone,
 *     weeks: [{ weekStart: 'YYYY-MM-DD', total, bySource: { answer: n } }],
 *     sources: [answer, ...] }   // busiest first
 */
export async function getLeadTrends({ weeks = 12, form = '' } = {}) {
  const params = { weeks };
  if (form) params.form = form;
  const { data } = await api.get('/v2/lead-form/trends', { params });
  return data || { enabled: false };
}
